import styled from "styled-components";
import Button from "../Buttons/Button";
import IconButton from "../Buttons/IconButton";
import { withAlpha } from "../../styles/utils";

export const AssignmentsWrapper = styled.section`margin-top: 22px;`;

export const AssignmentsHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 10px;
`;

export const AssignmentsHeading = styled.h3`
  margin: 0;
  color: ${({ theme }) => theme.colors.inkHex};
  font-size: 15px;
  font-weight: 600;
  line-height: 1.4;
`;

export const AddAssignmentButton = styled(Button)`
  width: auto;
  min-width: 0;
  max-width: none;
  height: 32px;
  padding: 0 11px;
  border: 1px solid ${({ theme }) => withAlpha(theme.colors.inkHex, 0.14)};
  border-radius: 10px;
  background: transparent;
  color: ${({ theme }) => theme.colors.inkHex};
  font-family: inherit;
  font-size: 13px;
  font-weight: 500;
  line-height: 1;
  white-space: nowrap;
  box-shadow: none;
  transition: background-color 0.15s ease, border-color 0.15s ease;

  &:hover:not(:disabled) {
    border-color: ${({ theme }) => withAlpha(theme.colors.inkHex, 0.14)};
    background: ${({ theme }) => withAlpha(theme.colors.inkHex, 0.05)};
    color: ${({ theme }) => theme.colors.inkHex};
  }
  &:active:not(:disabled) { background: ${({ theme }) => withAlpha(theme.colors.inkHex, 0.05)}; }
  &:focus-visible { outline: 2px solid ${({ theme }) => theme.colors.brand}; outline-offset: 2px; }
  &:disabled { cursor: default; opacity: 0.45; }
`;

export const AssignmentsList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

export const Container = styled.article`
  padding: 14px 16px;
  border: 1px solid ${({ theme }) => withAlpha(theme.colors.inkHex, 0.14)};
  border-radius: 12px;
  background: ${({ theme }) => theme.colors.white};
`;

export const AssignmentTop = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
`;

export const AssignmentContentWrapper = styled.div`min-width: 0; flex: 1 1 auto;`;

export const AssignmentsTitle = styled.h4`
  margin: 0;
  color: ${({ theme }) => theme.colors.inkHex};
  font-size: 14px;
  font-weight: 500;
  line-height: 1.45;
`;

export const AssignmentsDescription = styled.p`
  margin: 5px 0 0;
  color: ${({ theme }) => withAlpha(theme.colors.inkHex, 0.64)};
  font-size: 13px;
  font-weight: 400;
  line-height: 1.5;
  white-space: pre-wrap;
`;

export const AssignmentMeta = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 6px;
  margin-top: 10px;
`;

export const AssignmentTag = styled.a`
  display: inline-flex;
  align-items: center;
  gap: 5px;
  max-width: 240px;
  height: 24px;
  padding: 0 8px;
  overflow: hidden;
  border-radius: 6px;
  background: ${({ theme }) => withAlpha(theme.colors.inkHex, 0.05)};
  color: ${({ theme }) => withAlpha(theme.colors.inkHex, 0.64)};
  font-size: 12px;
  font-weight: 400;
  line-height: 1;
  text-decoration: none;
  white-space: nowrap;
  &[href]:hover { color: ${({ theme }) => theme.colors.brand}; }
  svg { width: 11px; height: 14px; flex: 0 0 auto; color: ${({ theme }) => theme.colors.brand}; }
  span { overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
`;

export const ActionButtonsWrapper = styled.div`
  display: flex;
  flex: 0 0 auto;
  align-items: center;
  gap: 2px;
`;

export const AssignmentIconButton = styled(IconButton)<{ $danger?: boolean }>`
  width: 32px;
  min-width: 32px;
  height: 32px;
  padding: 0;
  border: 0;
  border-radius: 8px;
  background: transparent;
  color: ${({ theme }) => withAlpha(theme.colors.inkHex, 0.42)};
  transform: none;
  &:hover {
    background: ${({ $danger, theme }) => $danger ? "rgba(176, 48, 76, 0.08)" : withAlpha(theme.colors.inkHex, 0.05)};
    color: ${({ $danger, theme }) => $danger ? "rgb(176, 48, 76)" : theme.colors.inkHex};
    transform: none;
  }
  &:focus-visible { outline: 2px solid ${({ theme }) => theme.colors.brand}; outline-offset: 2px; }
  svg { width: 17px; height: 17px; }
`;

export const EmptyAssignments = styled.div`
  padding: 18px;
  border: 1px dashed ${({ theme }) => withAlpha(theme.colors.inkHex, 0.26)};
  border-radius: 12px;
  color: ${({ theme }) => withAlpha(theme.colors.inkHex, 0.42)};
  font-size: 13px;
  font-weight: 400;
  line-height: 1.5;
  text-align: center;
`;

export const LoadingText = styled.div`
  padding: 12px 0;
  color: ${({ theme }) => withAlpha(theme.colors.inkHex, 0.42)};
  font-size: 13px;
`;
